export default function Home () {
  return (
    <div className="w-full">
      <img className="mx-auto" src="https://media.giphy.com/media/3o751Xx1OBDhoOvMT6/giphy.gif" alt="Amazing gif" />
      <h1 className="font-xl animate-spin font-bold text-center my-36">VELKOMMEN TIL REBUS 2022</h1>
      <img className="mx-auto" src="https://media.giphy.com/media/3ohs4C4rwFlxOnDAUE/giphy.gif" alt="Amazing gif 2" />
    </div>
  )
}